import { createSelector } from 'reselect'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import libraryTypes from 'helpers/enums/libraryTypes'

const myLibrarySelector = state => state.myLibrary
const getLti = state => state.lti

const myLibraryTeachModalSelector = createSelector(
	[myLibrarySelector, getLti],
	(myLibrary, lti) => {
		const libraryType = formatLibraryType(lti)
		const externalLibraries = [libraryTypes.LTI, libraryTypes.TEAMS, libraryTypes.EXTENSION]
		const isExternalLibrary = externalLibraries.includes(libraryType)

		return {
			hasMultipleLiveSessionPins: !!myLibrary.liveCodes.multiplePins,
			hasActiveLiveCodes: !isExternalLibrary && (
				(myLibrary.liveCodes.multiplePins && myLibrary.liveCodes.activePins.length > 0) ||
				(!myLibrary.liveCodes.multiplePins && !!myLibrary.liveCodes.session_uid)
			),
			hasActiveHomeworkCodes: !isExternalLibrary &&
				!!myLibrary.homeworkCodes.multiplePins &&
				myLibrary.homeworkCodes.activePins.length > 0,
		}
	}
)

export default myLibraryTeachModalSelector
